/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAxisY2 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M3 2H2v20h4v-2H4V4h2V2zm4.293 4.707L12 11.414V19h2v-7.586l4.707-4.707-1.414-1.414L13 9.586 8.707 5.293zM17 20.625v.945h4.257v-1.143h-2.43l.909-.999c.372-.414.666-.768.882-1.062.222-.3.381-.57.477-.81s.144-.48.144-.72c0-.588-.192-1.041-.576-1.359S19.739 15 19.043 15c-.312 0-.633.042-.963.126a4.101 4.101 0 0 0-.909.333v1.206c.618-.33 1.17-.495 1.656-.495.69 0 1.035.273 1.035.819 0 .132-.036.276-.108.432-.072.15-.198.336-.378.558-.174.216-.42.498-.738.846z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgChartAxisY2 as ChartAxisY2 };
